import * as yup from 'yup';

export const GROWING_ZONES = Array.from({
  length: 13,
}).flatMap((_unused, i) => [`${i + 1}a`, `${i + 1}b`]);

// Add 'None' growing zone option (stored as NULL in the database)
export const FARM_GROWING_ZONES = [...GROWING_ZONES, 'None'];

export const growingZoneSchema = yup
  .string()
  .transform((value) => value || 'None') // Convert empty value to 'None'
  .oneOf(FARM_GROWING_ZONES, 'Invalid growing zone');
